import {
    AddToQueue,
    Air,
    AirplayRounded,
    Output,
    RecordVoiceOver,
    SettingsInputHdmi,
} from "@mui/icons-material";
import {
    faBarcode,
    faBug,
    faCalendar,
    faClock,
    faDisplay,
    faEthernet,
    faHouseUser,
    faLaptop,
    faMicrochip,
    faNetworkWired,
    faPeopleRoof,
    faRotate,
    faShieldHalved,
    faSignal,
    faUser,
    faVideo,
    faVirus,
    faUserCheck,
    faIdCard,
    faBuilding,
    faMapMarkerAlt
} from "@fortawesome/free-solid-svg-icons";
import { faChromecast, faGoogle } from "@fortawesome/free-brands-svg-icons";
import WebexCategorie from "../../../Webex/WebexCategorie";
import { t } from "i18next";

/**
 * 
 * @param {object} item - device from sentinelOne devices 
 */
export default function RowDevices({ item }) {
    const devicesStatus = {
        idDevices: [
            { value: item.serialNumber, title: t("Numéro de série"), multiple: false, number: false, iconType: "fontAwesome", icon: faBarcode },
            { value: item.computerName, title: t("Nom du device"), multiple: false, number: false, iconType: "fontAwesome", icon: faLaptop },
        ],
        securityStatut: [
            { value: item.activeThreats, title: t("Menaces actives"), multiple: false, number: true, iconType: "fontAwesome", icon: faBug },
            { value: item.infected, title: t("État de l'infection"), multiple: false, number: false, iconType: "fontAwesome", icon: faVirus },
            { value: item.mitigationMode, title: t("Mode de mitigation"), multiple: false, number: false, iconType: "fontAwesome", icon: faShieldHalved },
            { value: item.networkQuarantineEnabled, title: t("Quarantaine réseau"), multiple: false, number: false, iconType: "Mui", icon: <RecordVoiceOver /> },
            { value: item.firewallEnabled, title: t("Pare-feu"), multiple: false, number: false, iconType: "Mui", icon: <Air /> },
        ],
        reseau: [
            { value: item.externalIp, title: t("IP externe"), multiple: false, number: false, iconType: "fontAwesome", icon: faNetworkWired },
            { value: item.lastIpToMgmt, title: t("Dernière IP gérée"), multiple: false, number: false, iconType: "fontAwesome", icon: faVideo },
            { value: item.networkStatus, title: t("État du réseau"), multiple: false, number: false, iconType: "Mui", icon: <AddToQueue /> },
            { value: item.networkInterfaces, title: t("Interfaces réseau"), multiple: true, number: false, iconType: "fontAwesome", icon: faSignal, status: false },
        ],
        osMaterial: [
            { value: item.osName, title: t("Nom du système d'exploitation"), multiple: false, number: false, iconType: "fontAwesome", icon: faDisplay },
            { value: item.osRevision, title: t("Révision du système d'exploitation"), multiple: false, number: true, iconType: "fontAwesome", icon: faRotate },
            { value: item.coreCount, title: t("Nombre de cœurs"), multiple: false, number: true, iconType: "fontAwesome", icon: faMicrochip },
            { value: item.cpuCount, title: t("Nombre de processeurs"), multiple: false, number: true, iconType: "fontAwesome", icon: faMicrochip },
            { value: item.totalMemory + ' Go', title: t("Mémoire totale"), multiple: false, number: true, iconType: "fontAwesome", icon: faMicrochip },
            { value: item.modelName, title: t("Nom du modèle"), multiple: false, number: false, iconType: "fontAwesome", icon: faLaptop },
        ],
        utilisateur: [
            { value: item.lastLoggedInUserName, title: t("Nom d'utilisateur connecté"), multiple: false, number: false, iconType: "fontAwesome", icon: faUserCheck },
            { value: item.accountName, title: t("Nom du compte"), multiple: false, number: false, iconType: "fontAwesome", icon: faIdCard },
        ],
        dates: [
            { value: item.createdAt, title: t("Date de création"), multiple: false, number: false, iconType: "fontAwesome", icon: faClock },
            { value: item.lastActiveDate, title: t("Dernière activité"), multiple: false, number: false, iconType: "fontAwesome", icon: faCalendar },
            { value: item.lastSuccessfulScanDate, title: t("Dernière analyse réussie"), multiple: false, number: false, iconType: "Mui", icon: <AirplayRounded /> },
        ],
        sites: [
            { value: item.groupName, title: t("Nom du groupe"), multiple: false, number: false, iconType: "fontAwesome", icon: faBuilding },
            { value: item.siteName, title: t("Nom du site"), multiple: false, number: false, iconType: "fontAwesome", icon: faMapMarkerAlt },
        ]
    }

    return (
        <>
            <div className="webex-container">
                <WebexCategorie array={devicesStatus.idDevices} categorie="Identification du device" />
                <WebexCategorie array={devicesStatus.securityStatut} categorie="Statut de sécurité" />
            </div>
            <div className="webex-container">
                <WebexCategorie array={devicesStatus.reseau} categorie="Réseau" />
                <WebexCategorie array={devicesStatus.utilisateur} categorie="Utilisateur" />
            </div>
            <div className="webex-container">
                <WebexCategorie array={devicesStatus.dates} categorie="Dates" />
                <WebexCategorie array={devicesStatus.sites} categorie="Sites" />
            </div>
            <div className="webex-resume">
                <WebexCategorie array={devicesStatus.osMaterial} categorie="Matériels du système d'exploitation" />
            </div>
        </>
    )
}